import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { isMobileUA } from 'dpl/shared/utils';
import withLazyLoading from 'dpl/decorators/withLazyLoading';

import TipsSlider from '../components/TipsSlider';
import MobileTipsSlider from '../components/MobileTipsSlider';

const isMobile = isMobileUA();
function TipsSliderContainer(props) {
  return isMobile ? <MobileTipsSlider {...props} /> : <TipsSlider {...props} />;
}

export default compose(
  connect(({ server: { tips } }) => ({
    tips
  })),
  withLazyLoading({
    defaultLazy: !isMobile
  })
)(TipsSliderContainer);
